import * as React from "react";
const SvgFiRrPending = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pending_svg__a)">
      <path
        fill="#062147"
        d="M15.999 15.5a1 1 0 0 1-.548-.164l-4-2.628a1 1 0 0 1-.451-.836V7a1 1 0 1 1 2 0v4.333l3.549 2.331a1 1 0 0 1-.55 1.836m-3.285 6.475A10 10 0 0 1 12 22C6.486 22 2 17.514 2 12S6.486 2 12 2c3.151 0 6.112 1.512 7.988 4H17a1 1 0 1 0 0 2h4c1.103 0 2-.897 2-2V2a1 1 0 1 0-2 0v2.104C18.743 1.543 15.473 0 12 0 5.383 0 0 5.383 0 12s5.383 12 12 12q.432 0 .856-.031a1 1 0 0 0 .926-1.068.99.99 0 0 0-1.068-.926M23 11a1 1 0 0 0-1 1c0 .455-.031.913-.092 1.36a1 1 0 0 0 1.982.27c.072-.536.109-1.085.109-1.63 0-.553-.446-1-.999-1m-.863 5.396a.997.997 0 0 0-1.357.396c-.217.396-.464.782-.735 1.148a1.002 1.002 0 0 0 .804 1.594c.307 0 .609-.141.806-.405.323-.439.62-.902.88-1.377a1 1 0 0 0-.396-1.357zm-4.731 4.02a10 10 0 0 1-1.191.656 1 1 0 1 0 .842 1.814c.491-.229.973-.493 1.432-.789a1 1 0 1 0-1.082-1.682z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pending_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPending;
